
export interface IDbConfigResponse {
    patentCountries: PatentCountriesResponse;
}

export interface PatentCountriesResponse {
    major: string[];
    others: string[];
    ip5: string[];
}
export interface PatentDbApi {
    /**
     * 获取专利数据库配置
     */
    getDbConfig(): Promise<IDbConfigResponse>;
}

export const PatentDbApi = Symbol.for('PatentDbApi');
